import { UserRole } from '@/http/api/users'

export type Permission =
  | 'access-company'
  | 'access-learning'
  | 'configure-company'
  /** Allows managing users */
  | 'manage-company'
  /** Allows creating and editing learning content, courses, events and learning paths */
  | 'create-learning'
  /** Allows managing users in learning content, courses, and learning paths */
  | 'manage-learning'

export type Role = {
  id: UserRole
  type: 'core' | 'custom' | 'system'
  permissions: Permission[]
}

export const companyRoles: Role[] = [
  {
    id: 'admin',
    type: 'system',
    permissions: [
      'access-company',
      'manage-company',
      'create-learning',
      'manage-learning',
    ],
  },
  {
    id: 'public_api_client',
    type: 'system',
    permissions: [],
  },
  {
    id: 'owner',
    type: 'core',
    permissions: [
      'access-company',
      'configure-company',
      'manage-company',
      'create-learning',
      'manage-learning',
    ],
  },
  {
    id: 'company_administrator',
    type: 'core',
    permissions: [
      'access-company',
      'configure-company',
      'manage-company',
      'create-learning',
      'manage-learning',
    ],
  },
  {
    id: 'manager',
    type: 'core',
    permissions: [
      'access-company',
      'manage-company',
      'create-learning',
      'manage-learning',
    ],
  },
  {
    id: 'student',
    type: 'core',
    permissions: ['access-learning'],
  },
  {
    id: 'content_creator',
    type: 'custom',
    permissions: ['access-company', 'create-learning'],
  },
]
